import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=5a72fedb&"
import script from "./CategoryFilters.vue?vue&type=script&lang=js&"
export * from "./CategoryFilters.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFilters.vue?vue&type=style&index=0&id=5a72fedb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports